import  React, {  Component} from "react"
import cognitoUtils from '../lib/cognito';
import { connect, ReactReduxContext } from 'react-redux'

class Authenticate extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    redirectToLogin() {
        window.location.assign(cognitoUtils.getCognitoSignInUri());
    }

        
    componentDidMount() {
        if(this.props.session.isLoggedIn == null || !this.props.session.isLoggedIn)
        {
            this.redirectToLogin();
        }
    }

    render() { 
        const { children } = this.props;
        return ( 
            <>
              {children}
            </>
         );
    }
}
 
const mapStateToProps = state => {
    return { session: state.session }
}

export default connect(mapStateToProps)(Authenticate);   